module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": _vm.title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "faq-response"
  }, [_c('p', [_vm._v("\n            The Authority administers a variety of federal and state grant programs.\n            "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/grants/overview#tab_grant-programs"
    }
  }, [_vm._v("View programs")]), _vm._v(" to see if your organization\n            meets the eligibility requirements of an Authority-administered program. Then\n            "), _c('router-link', {
    attrs: {
      "to": "/grants"
    }
  }, [_vm._v("visit grant opportunities")]), _vm._v(" to see if we are accepting grant applications for the program.")], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "faq-response"
  }, [_c('p', [_vm._v("When you see a grant opportunity listed on the\n          "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Authority's GATA website")]), _vm._v(", check to make sure your agency meets the program's specific criteria for\n          grant funding. If your agency is eligible for funding, read the instructions for information on how to submit an\n          application.")], 1)]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-question first"
  }, [_c('p', [_vm._v("\n            I have a program and am in need of grant funding. What programs do you administer?\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-question"
  }, [_c('p', [_vm._v("What are the funding cycles?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-response"
  }, [_c('p', [_vm._v("Federal programs are funded from October 1 to September 30. State programs are funded from July 1 to June 30.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-question"
  }, [_c('p', [_vm._v("How do I find out about grant opportunities?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-response"
  }, [_c('p', [_vm._v("Find out about Authority grant opportunities, news, and research by checking the "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us"
    }
  }, [_vm._v("ICJIA website")]), _vm._v(",\n            "), _c('a', {
    attrs: {
      "href": "https://visitor.r20.constantcontact.com/manage/optin?v=001MqUcqqvjwLCJXlLMSWbTe3zHHmEQgFeBuHvBcJWTbwgrxFbDSGx4HSUPpI6DJWMUPgbljtLxffqIcGFTgCnr-auak88ybvRxpoJlTMGPtZs%3D"
    }
  }, [_vm._v("subscribing to the CJ Dispatch")]), _vm._v(",\n            and following us on "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/ICJIA/"
    }
  }, [_vm._v("Facebook")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://twitter.com/icjia_illinois?lang=en"
    }
  }, [_vm._v("Twitter")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-question"
  }, [_c('p', [_vm._v("How do I apply for a grant?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-question"
  }, [_c('p', [_vm._v("We tried to apply for a grant but had problems with the application process. What should we do?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-response"
  }, [_c('p', [_vm._v("Please use the "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/contact"
    }
  }, [_vm._v("Authority\n  contact information")]), _vm._v(" on the request for applications for technical assistance at any point in the process.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card well",
    attrs: {
      "id": "gata-procedueral-webinar"
    }
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("GATA General Procedural Common FAQs webinar")]), _vm._v(" "), _c('p', [_vm._v("This webinar answers frequently asked questions about the grant review process. Topics include rules and regulations,\n          common errors on applications, certifications, and budgetary issues.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "16rem",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "g18hgiS3RYI",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added May 2017")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a085f130"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Faqs.vue
// module id = 391
// module chunks = 0